module.exports = __webpack_public_path__ + "static/media/logo-asisa-blue.2c97e31a.svg";